import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraBadge, SpecraLink } from '@mono/ui-components/ensigns';
import { SpecraTooltip } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { registryHref } from '../../registryHref';
import { umbrellaPath, umbrellaVia } from './companyIdentity';
/**
 * "Part of Accenture plc" (SAD-1333): the ultimate parent the company sits
 * under today. The tooltip shows the whole chain and how the first step works
 * ("subsidiary of Cognosante LLC"); the pill links to the parent's page.
 */ // specra-allow local-composite: a link and tooltip (the ownership chain) around SpecraBadge, not a new pill
export function UmbrellaPill({ companyName, umbrella, familyHref }) {
    const parent = umbrella?.parent;
    if (!umbrella || !parent?.id) return null;
    const first = umbrella.path[0]?.company?.name ?? parent.name;
    const tip = /*#__PURE__*/ _jsxs("span", {
        className: "block max-w-xs space-y-1",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "block",
                children: umbrellaPath(companyName, umbrella)
            }),
            /*#__PURE__*/ _jsxs("span", {
                className: "block",
                children: [
                    umbrellaVia(umbrella),
                    " ",
                    first
                ]
            }),
            familyHref && /*#__PURE__*/ _jsx(SpecraLink, {
                href: familyHref,
                renderLink: renderRouterLink,
                children: "Open family view"
            })
        ]
    });
    return /*#__PURE__*/ _jsx(SpecraTooltip, {
        content: tip,
        children: /*#__PURE__*/ _jsx(SpecraLink, {
            href: registryHref({
                kind: 'COMPANY',
                id: parent.id
            }) ?? undefined,
            renderLink: renderRouterLink,
            "aria-label": `Part of ${parent.name}: ${umbrellaPath(companyName, umbrella)}`,
            "data-testid": Testids.registryCompany.umbrellaPill,
            children: /*#__PURE__*/ _jsxs(SpecraBadge, {
                variant: "neutral",
                children: [
                    "Part of ",
                    parent.name
                ]
            })
        })
    });
}
